import { features } from '@/lib/features';
const getMarketingOptinContentKey = ({
  isSelectAllExperience,
}: {
  isSelectAllExperience: boolean;
}): string => {
  if (isSelectAllExperience) {
    return 'simplifiedSectionHeaders.multiTerms.marketingOptIn.terms';
  }

  const isStreamlineExperience = features.someActive(
    'isStreamlineOptionalExperience',
    'isStreamlineForcedExperience',
  );
  return isStreamlineExperience
    ? 'simplifiedSectionHeaders.marketingOptIn.terms'
    : 'terms.marketingOptIn';
};

export { getMarketingOptinContentKey };
